import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import AdditionalInfo from 'src/Components/AdditionalInfo'
import { Button, If, Text } from 'src/Components'
import ButtonGroup from 'src/Components/Button/ButtonGroup'
import { NumberedList } from 'src/Components/List'
import LoanBalance from '../LoanBalance/LoanBalance'

import styles from './ShowPaidExtra.module.scss'

const ShowPaidExtra = ({ loanDetails, onSubmit, onCancel }) => {
  return (
    <Fragment>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.interest.paidExtra.headline'
          defaultMessage='What have you paid towards principal?'
        />
      </AdditionalInfo.Heading>
      <Text size='s' align='left' className={styles.paidExtraSubHeader}>
        <FormattedMessage
          id='Homeowner.interest.paidExtra.subheadline'
          defaultMessage='We calculate all of your numbers based on loan details and today’s balance.'
        />
      </Text>
      <form onSubmit={onSubmit} className={styles.paidExtraForm}>
        <div className={styles.numberedListWrapper}>
          <If condition={loanDetails.length > 1}>
            <NumberedList
              render={LoanBalance}
              items={loanDetails}
              itemKey={'uuid'}
            />
          </If>
          <If condition={loanDetails.length === 1}>
            <div className={styles.singleLoan}>
              <LoanBalance {...loanDetails[0]} />
            </div>
          </If>
        </div>
        <ButtonGroup className={styles.saveOrCancelButton}>
          <Button primary type='submit'>
            <FormattedMessage
              id='Homeowner.interest.paidExtra.saveButton'
              defaultMessage='Save'
            />
          </Button>
          <Button minimal type='button' onClick={onCancel}>
            <FormattedMessage
              id='Homeowner.interest.paidExtra.cancelButton'
              defaultMessage='or cancel'
            />
          </Button>
        </ButtonGroup>
      </form>
    </Fragment>
  )
}

export default ShowPaidExtra
